import SvgMicrophone02 from "@uui/Microphone02";
import { isEmpty, times } from "lodash/fp";

import { Skeleton, Stack, Typography } from "@mui/material";

import ErrorContent from "@app/analytics/WorkspaceOverview/components/ErrorContent";

import ParticipationTable from "./ParticipationTable";
import useParticipation from "./useParticipation";
import EmptyContent from "../components/EmptyContent";
import ModuleHeader from "../components/ModuleHeader";
import ModuleLegendItem from "../components/ModuleLegendItem";
import ModuleTitle from "../components/ModuleTitle";
import { WorkspaceModule, WorkspaceModuleBody } from "../components/styles";

const LoadingState = () => (
  <Stack spacing={1} sx={{ width: "100%" }}>
    {times(
      (i) => (
        <Skeleton
          key={i}
          variant="rectangular"
          sx={{ borderRadius: "8px", height: "35px", width: "100%" }}
        />
      ),
      5
    )}
  </Stack>
);

const Participation = () => {
  const { isInitialLoading, isError, refetch, tableData, overallData } =
    useParticipation();

  return (
    <WorkspaceModule>
      <ModuleHeader>
        <ModuleTitle icon={SvgMicrophone02}>Participation</ModuleTitle>
      </ModuleHeader>
      <WorkspaceModuleBody sx={{ pt: 2, flex: 1 }}>
        <Typography
          variant="bodySecondaryReg"
          sx={{ color: "shades.neutral.600" }}
        >
          Talk time distribution in meetings
        </Typography>
        <Stack direction="row" spacing={2} sx={{ py: 2 }}>
          <Typography
            variant="bodySecondaryReg"
            sx={{ color: "shades.neutral.500" }}
          >
            Participation:
          </Typography>
          <ModuleLegendItem
            label="Balanced talk time"
            color="scores.positive"
          />
          <ModuleLegendItem
            label="Unbalanced talk time"
            color="scores.negative"
          />
        </Stack>
        {isInitialLoading ? (
          <LoadingState />
        ) : isError ? (
          <ErrorContent onRetry={refetch} sx={{ height: "250px" }} />
        ) : isEmpty(tableData) ? (
          <EmptyContent sx={{ height: "250px" }} />
        ) : (
          <ParticipationTable data={tableData} overallData={overallData} />
        )}
      </WorkspaceModuleBody>
    </WorkspaceModule>
  );
};

export default Participation;
